import Animated from "./Animated";

export default Animated;
